<template>
  <nuxt-link
    to="/shop/warenkorb"
    data-tealium-rel="header.button.warenkorb"
    class="cart-indicator btn btn--no-style"
    active-class="cart-indicator--active"
    :aria-label="`Warenkorb, ${cartQuantity === 1 ? '1 Produkt' : `${cartQuantity || 0} Produkte`}`"
  >
    <SvgIcon
      no-icon-class
      class="cart-indicator__icon"
      :class="iconClass"
      :image="cartIcon"
    />
    <slot />
    <CountBadge
      v-if="cartQuantity"
      :value="cartQuantity"
      class="cart-indicator__count"
    />
  </nuxt-link>
</template>

<script setup lang="ts">
import { withDefaults } from 'vue';
import { storeToRefs } from 'pinia';
import cartIcon from '~/assets/images/navigation/basket.svg';
import CountBadge from '~/components/count-badge.vue';
import { useCartStore } from '~/stores/cart';

export type CartIndicatorProps = {
  iconClass?: string;
};

const props = withDefaults(defineProps<CartIndicatorProps>(), {
  iconClass: undefined,
});

const { cartQuantity } = storeToRefs(useCartStore());
</script>

<style lang="scss">
@use 'assets/base' as *;

$component: '.cart-indicator';

#{$component} {
  position: relative;
  text-decoration: none;

  &__count {
    font-size: 12px;
    position: absolute;
    right: -7px;
    top: 10px;
  }

  .secondary-navigation &--active {
    color: var(--color-primary);
  }
}
</style>
